import React from "react"
import "./home-content.css";

class HomeContent extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        return (
            <div className="">
                <div className="one clear">
                    <h1 className="gray signature">Kamran Hamid</h1>
                    <h1 className="white">
                        Hi there, I am a full stack engineer with over <span className="gray">5 years</span> of experience working
                        on the web, servers and hybdird mobile apps.
                    </h1>
                    {/* <h3 className="white subHeading">
                        I'm working with my current employer for about <span className="gray">2 years</span>&nbsp;
                        and my role is <span className="gray">Senior Full-stack</span>. I possess the ability to learn
                        new languages and technologies rapidly and efficiently use that knowledge to
                        develop <span className="gray">powerful applications.</span>
                    </h3> */}
                </div>
                <div className="two">
                    <div className="experienceContainer">
                        <h2 className="gray underline">Experience</h2>
                        <div className="experienceList">
                            <div className="experience">
                                <h3 className="fl gray">Progstream Pvt. Ltd.</h3>
                                <h4 className="fr gray">2017-Present</h4>
                                <h4 className="clear white experienceRole">Senior Full-stack Engineer</h4>
                            </div>
                            <div className="experience">
                                <h3 className="fl gray">Panacloud Pvt. Ltd.</h3>
                                <h4 className="fr gray">2015-2017</h4>
                                <h4 className="clear white experienceRole">Software Engineer</h4>
                            </div>
                            <div className="experience">
                                <h3 className="fl gray">Trainer</h3>
                                <h4 className="fr gray">2017-2018</h4>
                                <h4 className="clear white experienceRole">HTML, CSS, JS, React.js, Node.js</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default HomeContent
